jQuery(document).ready(function() {
    
  jQuery('form.partner-frm').on('click', function(e) {
    var curr_time = new Date().getTime() / 1000;
    e.preventDefault();
    var val = jQuery('form.partner-frm input#p-search').val();
    if( val != "" ) {
    	var url = "https://www.bubsaustralia.com/pages/bubstrustedpartners?p-search="+val+"&sort_by="+curr_time;
        console.log(url);
        window.location.href = url;
    }
  });
  
  /*if( jQuery('.temp-supreme').length > 0 ) {
    
    loadBgImage();
    $(window).resize(function(){
      loadBgImage();
    });
  }*/
  
});

function loadBgImage() {
  /*
  var $this = jQuery('.collection-intro.supreme-intro');

  if (jQuery(window).width() > 750) {
    var bgImg = $this.data('bg-desktop');
    $this.css('background-image', 'url(' + bgImg + ')');
  }
  else {
    var bgImg = $this.data('bg-mobile');
    $this.css('background-image', 'url(' + bgImg + ')');
  }
  */
}


jQuery(function($){
  if($('#jw_has_popup').length > 0){
    $('.jw-popup-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true
	});

    $('#jw-popup-modal-target').trigger('click');
  }

  if($('#career_page_wrapper').length > 0){
     function scrollToCareerTarget(aid,win_width){
            if($(aid).length > 0){
              if(win_width < 767){
                var aTag = $(aid).offset().top -80 ;
              }else{
                var aTag = $(aid).offset().top - 140;
              }
                
            
                $('html,body').animate({scrollTop: aTag});
             // $('html,body').scrollTop( aTag );
            }
     }
    
    $('.career_why_work_at_bubs_box_block').click(function(){
      
      var current_target = $('#career_current_target').val();
      var my_target = $(this).data('show-detail');
      var my_target_scroll = '#'+my_target;
      var win_width = $(window).width();
       var my_detail = $(this).find('.career_why_work_at_bubs_box_detail').html();
      $('#'+my_target + ' .career_show_detail').html(my_detail);
      $('#career_current_target').val(my_target);
      if($(this).hasClass('career_show_detail_flag')){
         $('#'+my_target + ' .career_show_detail').slideUp();
         $('.career_why_work_at_bubs_box_block').removeClass('career_show_detail_flag');
         $('.career_why_work_at_bubs_box_arrow').fadeOut();
      } else{
         //scrollToCareerTarget(my_target_scroll,win_width);
         $('.career_why_work_at_bubs_box_block').removeClass('career_show_detail_flag');  
         $('.career_why_work_at_bubs_box_arrow').fadeOut();
        
        if(current_target != my_target){
           $('.career_show_detail').slideUp('slow');
        }else{
          
        }
     
          $(this).addClass('career_show_detail_flag');
         
           $(this).find('.career_why_work_at_bubs_box_arrow').fadeIn();
          $('#'+my_target + ' .career_show_detail').slideDown('slow');
      
  
         
       }
    });
  }

  //product image image slider
   if($('.jw-product-image-slider').length > 0){
    if($('.jw-product-image-slider .slider-nav').length > 0){
        $('.jw-product-image-slider .slider-for').slick({
          
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav',
       autoplay: false,
      autoplaySpeed: 3000,   
          draggable:false,
           responsive: [
            {
              breakpoint: 768,
              settings: { 
                  draggable:true         
              }
            }
          ]
      });
     
        $('.jw-product-image-slider .slider-nav').slick({
         
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          dots: false,
          //arrows: false,
          centerMode: true,
          focusOnSelect: true,
          draggable:false,
           responsive: [
            {
              breakpoint: 768,
              settings: { 
                slidesToShow: 2,
                 
              }
            }
          ]
        });
    }else{
       $('.jw-product-image-slider .slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
       // asNavFor: '.slider-nav',
       autoplay: false,
      autoplaySpeed: 3000,   
      });
    }

     $('.prd_popup_gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		//mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return '';
			}
		}
	});
  }

  if($('.jw-mega-menu').length >0){
    var megaMenuTimeout;
    $('.jw-mega-menu').hover(
      function() {
         clearTimeout(megaMenuTimeout);
         $(this).find('.jw-mega-menu-columns').stop().slideDown();
      
      },
      function() {
      $(this).find('.jw-mega-menu-columns').stop().slideUp();
      }
    );
  }

  //FAQs style
  if($('.my_accordion').length >0){
  	$('.accordion_header').click(function() {
        $('.accordion_row').removeClass('acc-active');
        if ($(this).next().is(':visible')) {
            $(this).next().slideUp('normal');
            $('.accordion_row').removeClass('acc-active');
        }else {
            $(this).next().slideDown('normal');
            $(this).parent('.accordion_row').addClass('acc-active');
            $('.accordion_row:not(".acc-active") .accordion_body').slideUp('normal');
        }
    });
	
	$('.my_accordion .accordion_row:first-child .accordion_header').trigger('click');
    $('.stores.stores-list').addClass('jw-small-bottom-margin');
  }

  if($('.jw_home_carousel_inner').length >0){
    $('.jw_home_carousel_inner').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      autoplay: true,
  	  autoplaySpeed: 5000,
      fade: true,
      cssEase: 'linear'
    });
  }
  
});